/**
 * Pure theme → CSS custom properties for the locked VLSI brand theme.
 */
export function buildThemeCssVariables({ scheme, getColor }) {
  const variables = {};

  Object.entries(scheme.colors).forEach(([colorType, shades]) => {
    Object.entries(shades).forEach(([shade, value]) => {
      variables[`--color-${colorType}-${shade}`] = value;
    });
  });

  variables['--color-primary'] = getColor('primary', 500);
  variables['--color-primary-hover'] = getColor('primary', 600);
  variables['--color-primary-light'] = getColor('primary', 100);
  variables['--color-secondary'] = getColor('secondary', 500);
  variables['--color-accent'] = getColor('accent', 500);
  variables['--color-success'] = getColor('success', 500);
  variables['--color-warning'] = getColor('warning', 500);
  variables['--color-error'] = getColor('error', 500);

  variables['--color-text'] = getColor('neutral', 900);
  variables['--color-text-secondary'] = getColor('neutral', 600);
  variables['--color-text-muted'] = getColor('neutral', 500);

  variables['--color-background'] = getColor('neutral', 50);
  variables['--color-surface'] = '#ffffff';
  variables['--color-surface-elevated'] = getColor('neutral', 100);
  variables['--color-border'] = getColor('neutral', 200);

  return variables;
}
